import { render, staticRenderFns } from "./formPageTotal.vue?vue&type=template&id=24ecd7a0&scoped=true&lang=pug"
import script from "./formPageTotal.vue?vue&type=script&lang=js"
export * from "./formPageTotal.vue?vue&type=script&lang=js"
import style0 from "./formPageTotal.vue?vue&type=style&index=0&id=24ecd7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ecd7a0",
  null
  
)

export default component.exports